import script from "./BroadcastCampaignsReport.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadcastCampaignsReport.vue?vue&type=script&setup=true&lang=js"

import "./BroadcastCampaignsReport.vue?vue&type=style&index=0&id=eb56a18a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb56a18a"]])

export default __exports__